import React, {useCallback, useMemo} from 'react';
import {Modal} from 'antd';
import {useSideBarModal} from '../../../../layout/common/useSideBarModal';
import ModelDeleteDraftSideBarModal from './ModelDeleteDraftSideBarModal';
import {tid} from '../../../../../testUtils';
import SideBarButtonItem from '../../../../layout/common/SideBarButtonItem';
import {MODEL_ACTION_MENU_IDS} from '../../../../../test/types';
import {canDeleteDraftModel} from '../../../../../permissions/usePermissions';
import {ModelActionProps} from '../../../actionMenuTypes';
import {TrashCan16} from '@carbon/icons-react';
import {DeleteOutlined} from '@ant-design/icons';

const ModelDeleteDraftSideBarModalMenuButton: React.FC<Partial<ModelActionProps>> = ({model, newDesign, onSuccess}) => {
  const {buttonRef, openModal, closeModal} = useSideBarModal(model?.uuid);

  const handleSuccess = useCallback(() => {
    closeModal();
    onSuccess?.();
  }, [closeModal, onSuccess]);

  const ModalComponent = useMemo(() => {
    return (
      model && (
        <Modal
          open={!!buttonRef}
          onCancel={closeModal}
          footer={null}
          title={null}
          width={640}
          centered
          closable={false}
          maskClosable={false}
          destroyOnHidden
          bodyStyle={{
            padding: '2rem',
          }}
        >
          {!!buttonRef && (
            <ModelDeleteDraftSideBarModal model={model} onSuccess={handleSuccess} onCancel={closeModal} />
          )}
        </Modal>
      )
    );
  }, [buttonRef, closeModal, handleSuccess, model]);

  return (
    <>
      <SideBarButtonItem
        red
        {...tid(MODEL_ACTION_MENU_IDS.DELETE_DRAFT)}
        permission={canDeleteDraftModel(model)}
        onClick={openModal}
        icon={newDesign ? <DeleteOutlined /> : <TrashCan16 />}
        text="Delete Model Entry"
      />
      {ModalComponent}
    </>
  );
};

export default ModelDeleteDraftSideBarModalMenuButton;
